import {
    Box,
    Checkbox as MuiCheckbox,
    CheckboxProps,
    useTheme,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { CheckBoxIcon } from '../../eid-icons'
import { CheckedBoxIcon } from '../../eid-icons'
import React, { forwardRef } from 'react'

const StyledCheckbox = styled(MuiCheckbox)(({ theme }) => ({
    justifyContent: 'start',
    maxWidth: 'fit-content',
    borderRadius: '4px',
    '&:hover': {
        backgroundColor: 'transparent !important',
    },
    '&:focus': {
        outline: 'none',
    },
    '&:focus-visible': {
        outline: `2px solid ${theme?.palette?.primary?.main}`,
        outlineOffset: '2px',
    },
    '&.Mui-focusVisible': {
        outline: `2px solid ${theme?.palette?.primary?.main}`,
        outlineOffset: '2px',
    },
}))

const Checkbox = forwardRef<any, CheckboxProps>((props, ref) => {
    const theme = useTheme()

    return (
        <StyledCheckbox
            edge="start"
            color="primary"
            icon={
                <Box display="flex" alignItems="center">
                    <CheckBoxIcon />
                </Box>
            }
            checkedIcon={
                <Box display="flex" alignItems="center">
                    <CheckedBoxIcon color={theme.palette.primary.main} />
                </Box>
            }
            disableRipple
            disableFocusRipple
			onKeyDown={(event) => {
				if (event.key === 'Enter') {
					event.preventDefault()
					const root = event.currentTarget as unknown as HTMLElement
					const input = root.querySelector('input[type="checkbox"]') as HTMLInputElement | null
					if (input) {
						input.click()
					} else {
						root.click()
					}
				}
			}}
            ref={ref}
            {...props}
        />
    )
})

export default Checkbox
